export const withFormat = (day, names) => {
  const isM = day === 'tuesday' || day === 'wednesday';
  return names[day].substring(0, isM ? 2 : 1);
};
